var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "name",
            label: _vm._f("pgettext")("Name", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "name", required: "", autofocus: "" },
            model: {
              value: _vm.contact.name,
              callback: function($$v) {
                _vm.$set(_vm.contact, "name", $$v)
              },
              expression: "contact.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "job_title",
            label: _vm._f("pgettext")("Job Title", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "job_title" },
            model: {
              value: _vm.contact.job_title,
              callback: function($$v) {
                _vm.$set(_vm.contact, "job_title", $$v)
              },
              expression: "contact.job_title"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "phone",
            label: _vm._f("pgettext")("Phone Number", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "phone" },
            model: {
              value: _vm.contact.phone,
              callback: function($$v) {
                _vm.$set(_vm.contact, "phone", $$v)
              },
              expression: "contact.phone"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "mobile",
            label: _vm._f("pgettext")("Mobile Number", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "mobile" },
            model: {
              value: _vm.contact.mobile,
              callback: function($$v) {
                _vm.$set(_vm.contact, "mobile", $$v)
              },
              expression: "contact.mobile"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "email",
            label: _vm._f("pgettext")("Email", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "email" },
            model: {
              value: _vm.contact.email,
              callback: function($$v) {
                _vm.$set(_vm.contact, "email", $$v)
              },
              expression: "contact.email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fax",
            label: _vm._f("pgettext")("Fax", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "fax" },
            model: {
              value: _vm.contact.fax,
              callback: function($$v) {
                _vm.$set(_vm.contact, "fax", $$v)
              },
              expression: "contact.fax"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "notes",
            label: _vm._f("pgettext")("Notes", "Contact"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormTextarea", {
            attrs: { name: "notes" },
            model: {
              value: _vm.contact.notes,
              callback: function($$v) {
                _vm.$set(_vm.contact, "notes", $$v)
              },
              expression: "contact.notes"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }